module.exports = __webpack_public_path__ + "img/1zlFjrAlCEWK8Z50sbbVohxWb3-SFuXhy.c1fb5e01.png";